import _objectSpread from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import Head from "@/components/Head/index.vue";
import Upload from "@/components/UpLoadFile/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, reactive, ref } from "vue";
import { useRoute } from "vue-router";
export default defineComponent({
  components: {
    Head: Head,
    Upload: Upload
  },
  setup: function setup() {
    var route = useRoute();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var _route$query = route.query,
        optionId = _route$query.optionId,
        activityType = _route$query.activityType; // 获取个人资料

    var detail = reactive({
      detailContent: {
        option: {
          description: ""
        }
      },
      activityTypeId: activityType
    }); // 提交按钮文字

    var submitText = globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$btnText.$btn_submit;
    var baseUrl = process.env.VUE_APP_BASE_URL; // 详情回显

    var replyImg = ref([]);

    function getDetail() {
      return _getDetail.apply(this, arguments);
    }

    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getOptionDetail"](optionId);

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                detail.detailContent = _objectSpread({}, data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getDetail.apply(this, arguments);
    }

    onMounted(function () {
      // 详情
      getDetail();
    });
    return {
      submitText: submitText,
      optionId: optionId,
      detail: detail,
      baseUrl: baseUrl,
      replyImg: replyImg
    };
  }
});